import { render, staticRenderFns } from "./RiskControlInfo.vue?vue&type=template&id=1ea055a2&"
import script from "./RiskControlInfo.vue?vue&type=script&lang=js&"
export * from "./RiskControlInfo.vue?vue&type=script&lang=js&"
import style0 from "./RiskControlInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports